// extracted by mini-css-extract-plugin
export default {"image":"D2-z","loaded":"E2-z"};